import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const FeaturesSplit = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {

  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  const sectionHeader = {
    title: 'Features',
    paragraph: ''
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader id="features" data={sectionHeader} className="center-content" />
          <div className={splitClasses}>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Merge URLs
                </div>
                <h3 className="mt-0 mb-12">
                  One URL for up to 5 unique URLs 
                </h3>
                <p className="m-0">
                  We generate a single MergeURL tailored for up to 5 different exclusive URLs. 
                  We don't create two different MergeURLs for the same list of provided URLs. <br></br>
                  <br></br> Furthermore, if a MergeURL sits idle without any clicks associated with it for more than 12 months, 
                  we'll delete it due to inactivity.
                </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/feature-split-image-01.png')}
                  alt="Features split 01"
                  style={{ width: 400, height: 400 }} />
              </div>
            </div>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Open URLs
                </div>
                <h3 className="mt-0 mb-12">
                  Open your associated URLs in different tabs at once
                </h3>
                <p className="m-0">
                  You can open all the URLs associated with MergeURL at one go in your browser.
                  To use this feature, you can make use of our <i>/o/</i> extension appended to our domain name. <br></br>
                  <br></br> For example, <b><i>mergeurl.netlify.app/o/xxxxx</i></b> would open all the URLs associated with our link.
                </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/feature-split-image-02.png')}
                  alt="Features split 02"
                  style={{ width: 400, height: 400 }} />
              </div>
            </div>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  View URLs
                </div>
                <h3 className="mt-0 mb-12">
                View all your associated URLs at one place
                </h3>
                <p className="m-0">
                You can view all the URLs associated with MergeURL in one place in your browser. 
                To use this feature, you can make use of our /v/ extension appended to our domain name. <br></br>
                <br></br> For example, <b><i>mergeurl.netlify.app/v/xxxxx</i></b> would show all the URLs associated with our link.
                </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/feature-split-image-03.png')}
                  alt="Features split 03"
                  style={{ width: 400, height: 400 }} />
              </div>
            </div>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Instant service
                </div>
                <h3 className="mt-0 mb-12">
                  No login or signup will stop you, get your job done instantly. 
                </h3>
                <p className="m-0">
                  Are you tired of seeing login or signup forms that prevent you from getting your work done instantly? 
                  With MergeURL, you can get shortened links instantly with no user registration. <br></br> 
                  <br></br> To maintain an efficient, secure, and high-performing service, 
                  MergeURL places rate limits that restrict each user to generate hundered links per day.
                </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/feature-split-image-04.png')}
                  alt="Features split 04"
                  style={{ width: 400, height: 400 }} />
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

FeaturesSplit.propTypes = propTypes;
FeaturesSplit.defaultProps = defaultProps;

export default FeaturesSplit;
